import api from './api';

/**
 * Audit Log Service
 * Provides functions for logging user actions (exports, imports, etc.)
 */

/**
 * Log a report export action to the audit log
 * @param {Object} params - Export parameters
 * @param {string} params.reportName - Name of the report (e.g., "Report Summary", "Report School")
 * @param {string} params.exportFormat - Export format ("Excel" or "PDF")
 * @param {number} [params.activityId] - Activity ID (optional)
 * @param {number} [params.year] - Year (optional)
 * @param {string} [params.ppdCode] - PPD code (optional)
 * @param {string} [params.schoolCode] - School code (optional)
 * @param {string} [params.tahun] - Tahun/Grade (optional)
 * @param {number} [params.recordCount] - Number of records exported (optional)
 * @param {Object} [params.filters] - Additional filter parameters (optional)
 * @returns {Promise<void>}
 */
export const logReportExport = async (params) => {
  try {
    await api.post('/api/auditlog/log-export', {
      reportName: params.reportName,
      exportFormat: params.exportFormat,
      activityId: params.activityId || null,
      year: params.year || null,
      ppdCode: params.ppdCode || null,
      schoolCode: params.schoolCode || null,
      tahun: params.tahun || null,
      recordCount: params.recordCount || null,
      filters: params.filters || null
    });

    console.log(`✅ Audit log: ${params.reportName} exported as ${params.exportFormat}`);
  } catch (error) {
    // Don't throw error - audit logging failure should not block export
    console.error('Failed to log export audit:', error);
  }
};

/**
 * Example usage:
 *
 * await logReportExport({
 *   reportName: 'Report Summary',
 *   exportFormat: 'Excel',
 *   activityId: 1,
 *   year: 2025,
 *   ppdCode: 'PPD001',
 *   recordCount: 150,
 *   filters: { status: 'ACTIVE' }
 * });
 */

export default {
  logReportExport
};
